import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelEventoResponsavelCliente() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({});
    const [eventoResponsavelClientes, setEventoResponsavelClientes] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [page, setPage] = useState(1);
    const controllerRef = useRef(null);
    const pageSize = 15;

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/eventoResponsavelCliente',
            token: token,
            params: filtro,
            signal: controllerRef.current.signal
        })
            .then(response => {
                setEventoResponsavelClientes(response.data.data);
                setPage(1);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
                //console.log(err)
            });
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus();
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
    // eslint-disable-next-line
    []);

    const totalPaginas = Math.max(1, Math.ceil(eventoResponsavelClientes.length / pageSize));
    const linhas = eventoResponsavelClientes.slice((page - 1) * pageSize, page * pageSize);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Responsáveis no Cliente</h1>
                    </div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroEventoResponsavelCliente" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Novo Responsável
                        </Link>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ marginBottom: 16, padding: '16px' }}>
                    <form onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                        <div className="fin-pp__filters">
                            <FinField grow label="Nome">
                                <FinInput type="text" id="nome" placeholder="Buscar pelo nome"
                                    onChange={e => setFiltro({ ...filtro, nome: e.target.value })}
                                />
                            </FinField>
                            <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 2 }}>
                                <button type="submit" className="fin-pp__btn fin-pp__btn--primary">
                                    <FaSearch size={14} /> Buscar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl">
                            <thead>
                                <tr>
                                    <th style={{ width: 56 }}></th>
                                    <th style={{ width: 90, textAlign: 'right' }}>Código</th>
                                    <th>Nome</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando ? (
                                    <tr><td colSpan={3} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                ) : linhas.length === 0 ? (
                                    <tr><td colSpan={3} className="fin-pp__empty">Nenhum registro</td></tr>
                                ) : linhas.map(row => (
                                    <tr key={row.id}>
                                        <td>
                                            <Link to={`/cadastroEventoResponsavelCliente/${row.id}`} className="fin-pp__rowbtn">
                                                <FaPen size={14} />
                                            </Link>
                                        </td>
                                        <td className="fin-pp__cell-muted" style={{ textAlign: 'right' }}>{row.codigo}</td>
                                        <td className="fin-pp__cell-strong">{row.nome}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{eventoResponsavelClientes.length} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
